import { render, staticRenderFns } from "./FilterSearch.vue?vue&type=template&id=b22a159a&"
import script from "./FilterSearch.vue?vue&type=script&lang=js&"
export * from "./FilterSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports